import { render, staticRenderFns } from "./changeCardauditFail.vue?vue&type=template&id=12b8bec1&scoped=true&"
import script from "./changeCardauditFail.vue?vue&type=script&lang=js&"
export * from "./changeCardauditFail.vue?vue&type=script&lang=js&"
import style0 from "./changeCardauditFail.vue?vue&type=style&index=0&id=12b8bec1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b8bec1",
  null
  
)

export default component.exports